import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Generate a unique user ID
const generateUserId = (): string => {
  const timestamp = Date.now();
  const randomId = Math.random().toString(36).substring(2, 15);
  const url = window.location.href;
  const urlObj = new URL(url);
  const companyName = urlObj.pathname.split("/")[1];
  return `microsite-${companyName}-${timestamp}-${randomId}`;
};

const getUserId = (): string => {
  const storedUserId = localStorage.getItem("microsite-user-id");
  if (storedUserId) {
    return storedUserId;
  }
  const newUserId = generateUserId();
  localStorage.setItem("microsite-user-id", newUserId);
  return newUserId;
};

interface UserState {
  userId: string;
}

const initialState: UserState = {
  userId: getUserId()
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
      localStorage.setItem("microsite-user-id", action.payload);
    },
    resetUserId: state => {
      const newUserId = generateUserId();
      state.userId = newUserId;
      localStorage.setItem("microsite-user-id", newUserId);
    }
  }
});

export const { setUserId, resetUserId } = userSlice.actions;
export default userSlice.reducer;
